module.exports = __webpack_public_path__ + "static/img/5.f4063f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ban/5.png
// module id = 4QoG
// module chunks = 1